export { default, getStaticProps } from "app/page";
